import { Table } from '@mantine/core';
import { useParams } from 'react-router';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { query } from '../../util/api/query';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { formatToCurrency } from '../../util/formatting';
import type { ProductSaleDto } from '../../util/types/ReceiptViewDto';
import type { DepartmentDto } from '../departments/types/DepartmentDto';
import { KeyedRow } from '../../components/KeyedRow';

export function GroupProductSales() {
	const { organisation, departmentId } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const departmentsQuery = query<DepartmentDto>(
		`${organisation}/departments/get-department/${departmentId}`,
	);

	const productSalesQuery = queryWithFilterAndPages<ProductSaleDto[]>(
		`${organisation}/group-totals/get-sale-details/${departmentId}`,
		filter.value,
		pagination.value,
	);

	const productSalesCountQuery = queryWithFilter<number>(
		`${organisation}/group-totals/count-sale-details/${departmentId}`,
		filter.value,
	);

	return (
		<>
			<PageHeader
				title={departmentsQuery.data?.value.name ?? 'Loading...'}
				filter={filter}
			/>
			<DataTable
				pagination={pagination}
				totalItems={productSalesCountQuery.data?.value}
				isRowsLoading={productSalesQuery.isLoading}
				isPaginationLoading={productSalesCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'SKUID'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Name'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Quantity Sold'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Net Sales'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Gross Sales'} />
						</Table.Th>
						<Table.Th>
							<Title label={'VAT'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Discount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Individual Price'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>

				<Table.Tbody>
					{productSalesQuery.data?.value.map((product) => (
						<KeyedRow key={product.name}>
							<Table.Td>{product.skuid}</Table.Td>
							<Table.Td>{product.name}</Table.Td>
							<Table.Td>{product.soldCount}</Table.Td>
							<Table.Td>{formatToCurrency(product.netSales)}</Table.Td>
							<Table.Td>{formatToCurrency(product.grossSales)}</Table.Td>
							<Table.Td>{formatToCurrency(product.vat)}</Table.Td>
							<Table.Td>{formatToCurrency(product.discount)}</Table.Td>
							<Table.Td>{formatToCurrency(product.price)}</Table.Td>
						</KeyedRow>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
